import { render, staticRenderFns } from "./KeseminatanAdd.vue?vue&type=template&id=4f128b26&scoped=true"
import script from "./KeseminatanAdd.vue?vue&type=script&lang=js"
export * from "./KeseminatanAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f128b26",
  null
  
)

export default component.exports